<template>
  <i class="iconfont" :class="`icon-${name}`" v-on="$listeners"></i>
</template>
<script>
const url = process.env.VUE_APP_NAME;
import(`@/${url}/iconfont/iconfont.css`);
export default {
  props: {
    name: {
      type: String,
      required: false,
      default: 'font-awesome'
    }
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {}
};
</script>
<style lang="scss" scoped></style>
